import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

import Study from 'domain/services/teacher/study/Study';

interface IInitialState {
  loading: 'idle' | 'pending' | 'success' | 'failed';
  response: object;
  error: string;
  subjectIsUpdated: boolean;
  activeChapter: string;
  chapterAssignmentsLength: number;
  leafs: number;
}

const initialState: IInitialState = {
  loading: 'idle',
  response: [],
  error: null,
  subjectIsUpdated: false,
  activeChapter: null,
  chapterAssignmentsLength: 0,
  leafs: 0,
};

export const getStructureThunk = createAsyncThunk(
  'get-study-material-for-class',
  async (arg: string) => {
    return new Study().getTeachingStructureForSubject({ teaching_structure_id: arg });
  }
);

const StudyDetailsSlice = createSlice({
  name: 'teacher-study-material',
  reducers: {
    updateSubject(state, action) {
      state.subjectIsUpdated = action.payload;
    },
    setActiveChapter(state, action) {
      state.activeChapter = action.payload;
    },
    setChapterAssignmentsLength(state, action) {
      state.chapterAssignmentsLength = action.payload;
    },
    setLeafs(state, action) {
      state.leafs = action.payload;
    },
  },
  initialState,
  extraReducers: builder => {
    builder.addCase(getStructureThunk.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(getStructureThunk.fulfilled, (state, action) => {
      state.loading = 'success';
      state.response = action.payload;
    });
    builder.addCase(getStructureThunk.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
  },
});

const reducerState = state => state.studyDetailsSlice;

export const studyDetailsState = createSelector(reducerState, items => {
  return {
    teachingStructure: items.response,
    teachingStructureLoading: items.loading,
    subjectIsUpdated: items.subjectIsUpdated,
    activeChapter: items.activeChapter,
    chapterAssignmentsLength: items.chapterAssignmentsLength,
    leafs: items.leafs,
  };
});

export const { setActiveChapter, setChapterAssignmentsLength, setLeafs, updateSubject } =
  StudyDetailsSlice.actions;

export default StudyDetailsSlice.reducer;
